import Header from '../../components/feature/Header';
import Hero from './components/Hero';
import Services from './components/Services';
import Features from './components/Features';
import Gallery from './components/Gallery';
import Contact from './components/Contact';
import Footer from '../../components/feature/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-orange-50/30">
      <Header />
      <main>
        <Hero />
        <Services />
        <Features />
        <Gallery />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
